export default __webpack_public_path__ + "static/SectionTwo_01_02@2x-8f1d72c8b50f1894e3316175c263980d.webp";